export const FACEPAY_PORTAL = "FACEPAY_PORTAL"

export const FACEPAY_PORTAL_LOGIN = "FACEPAY_PORTAL_LOGIN"